(function () {

  let swakGuardActive = false;

  async function getAttemptedOrderType(button) {
    const card = button.closest('[data-order-type]');
    if (card) return card.dataset.orderType || null;

    const span = document.querySelector('[data-order-type]');
    if (span) return span.dataset.orderType || null;

    const li = button.closest('li');
    if (!li) return null;

    const href = li.querySelector('a')?.href;
    if (!href) return null;

    const handle = href.split('/products/')[1]?.split('?')[0];
    if (!handle) return null;

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      const tags = product.tags || [];

      const isRe = tags.includes('Room Essentials');
      const isOn = tags.includes('On-Campus');
      const isOff = tags.includes('Off-Campus');

      if (isRe && isOn) return 'On-Campus Room Essentials';
      if (isRe && isOff) return 'Off-Campus Room Essentials';
      if (isOn) return 'On-Campus Care Package';
      if (isOff) return 'Off-Campus Care Package';
    } catch (e) {
      console.error('SWAK: failed to fetch product tags', e);
    }

    return null;
  }

  function showError(message, anchor) {
    let errorEl = document.getElementById('swak-cart-guard-error');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.id = 'swak-cart-guard-error';
      errorEl.style.cssText = 'color: red; font-size: 0.95rem; font-weight: 700; margin-top: 0.75rem; max-width: 400px; line-height: 1.4;';
      if (anchor) anchor.insertAdjacentElement('afterend', errorEl);
      else document.body.appendChild(errorEl);
    }
    errorEl.innerHTML = message;
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearError() {
    const errorEl = document.getElementById('swak-cart-guard-error');
    if (errorEl) errorEl.innerHTML = '';
  }

  async function getCartOrderType() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (cart.items.length === 0) return null;
    return cart.attributes && cart.attributes['swak_order_type']
      ? cart.attributes['swak_order_type']
      : null;
  }

  // ===== SWAK CHANGE START — 2026-07-04 22:36 CDT — add swak_campus and _internal_order_code to cart attributes =====
async function stampCartOrderType(orderType) {
  const slug = (document.cookie.match(/(?:^|;\s*)swak_campus=([^;]+)/) || [])[1];
  const decodedSlug = slug ? decodeURIComponent(slug) : '';
  const campusData = (decodedSlug && window.SWAK_CAMPUS_DATA && window.SWAK_CAMPUS_DATA[decodedSlug])
    ? window.SWAK_CAMPUS_DATA[decodedSlug]
    : null;
  const internalOrderCode = campusData ? (campusData.internal_order_code || '') : '';

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        swak_order_type: orderType,
        swak_campus: decodedSlug,
        _internal_order_code: internalOrderCode
      }
    })
  });
}
// ===== SWAK CHANGE END — 2026-07-04 22:36 CDT — add swak_campus and _internal_order_code to cart attributes =====

   // ===== SWAK CHANGE START — 2026-07-02 22:04 CDT — update cart bubble after direct /cart/add.js POST =====
  async function updateCartBubble() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const count = cart.item_count || 0;

    const bubble = document.querySelector('[data-testid="cart-bubble"]');
    const bubbleWrapper = document.querySelector('.cart-bubble');
    const bubbleText = document.getElementById('cart-bubble-text');

    if (bubbleWrapper) {
      bubbleWrapper.classList.toggle('visually-hidden', count === 0);
    }
    if (bubble) {
      bubble.textContent = count;
      bubble.classList.toggle('hidden', count === 0);
    }
    if (bubbleText) {
      const visuallyHidden = bubbleText.querySelector('.visually-hidden');
      if (visuallyHidden) visuallyHidden.textContent = `Total items in cart: ${count}`;
    }

    console.log('SWAK: cart bubble updated to', count);
  }
  // ===== SWAK CHANGE END — 2026-07-02 22:04 CDT — update cart bubble after direct /cart/add.js POST =====

  // ─── Quick-Add Click Interceptor (capture phase) ──────────────────────────

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest(
      'add-to-cart-component button[name="add"], ' +
      'quick-add-drawer button[name="add"], ' +
      'quick-add-bulk button[name="add"], ' +
      '.quick-add__submit'
    );
    if (!btn) return;

    // Guard passed on previous check — let Horizon handle it natively
    if (btn.dataset.swakAllowed) {
      delete btn.dataset.swakAllowed;
      return;
    }

    if (swakGuardActive) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    swakGuardActive = true;
    btn.disabled = true;

    try {
      const attemptedType = await getAttemptedOrderType(btn);
      const cartType = await getCartOrderType();

      console.log('SWAK quick-add guard check:', { attemptedType, cartType });

      if (attemptedType && cartType && cartType !== attemptedType) {
        const anchor = btn.closest('li')
          || btn.closest('[role="dialog"]')
          || btn.closest('.modal')
          || btn.closest('form')
          || document.querySelector('h1')
          || null;
        showError(
          `Your cart already contains ${cartType} items. Please complete or clear your current order in the <a href="/cart" style="color:red;">cart</a> before adding ${attemptedType} items.`,
          anchor
        );
        btn.disabled = false;
        swakGuardActive = false;
        return;
      }

      // Guard passed — stamp order type then POST directly to /cart/add.js
      clearError();
      if (attemptedType) await stampCartOrderType(attemptedType);

      // ===== SWAK CHANGE START — 2026-07-02 20:46 CDT — replace btn.click() with direct /cart/add.js POST =====
      const form = btn.closest('form');
      const variantId = form
        ? (form.querySelector('[name="id"]')?.value || form.querySelector('[name="product-id"]')?.value)
        : null;
      const quantity = form?.querySelector('[name="quantity"]')?.value || 1;

      if (variantId) {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: Number(quantity) })
        });
        const addData = await addRes.json();
        console.log('SWAK: cart/add.js result:', addData);

        await updateCartBubble();

      } else {
        console.warn('SWAK: could not find variant ID — falling back to btn.click()');
        btn.dataset.swakAllowed = 'true';
        btn.disabled = false;
        btn.click();
        swakGuardActive = false;
        return;
      }
      // ===== SWAK CHANGE END — 2026-07-02 20:46 CDT — replace btn.click() with direct /cart/add.js POST =====

      btn.disabled = false;

    } catch (err) {
      console.error('SWAK quick-add guard error:', err);
      btn.disabled = false;
    }

    swakGuardActive = false;

  }, true); // <-- capture phase

  // ─── Form Submit Guard (product pages) ───────────────────────────────────

  function attachGuard(form) {
    if (form.dataset.swakGuarded) return;
    form.dataset.swakGuarded = 'true';

    let formBusy = false;

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (swakGuardActive) return;
      if (formBusy) return;

      const button = form.querySelector('button[name="add"]');
      if (!button) return;

      swakGuardActive = true;
      formBusy = true;
      button.disabled = true;

      try {
        const attemptedType = await getAttemptedOrderType(button);
        const cartType = await getCartOrderType();

        console.log('SWAK guard check:', { attemptedType, cartType });

        if (attemptedType && cartType && cartType !== attemptedType) {
          showError(
            `Your cart already contains ${cartType} items. Please complete or clear your current order in the <a href="/cart" style="color:red;">cart</a> before adding ${attemptedType} items.`,
            button
          );
          button.disabled = false;
          formBusy = false;
          swakGuardActive = false;
          return;
        }

        clearError();
        if (attemptedType) await stampCartOrderType(attemptedType);

        // ===== SWAK CHANGE START — 2026-07-02 20:32 CDT — fix null corruption on requestSubmit lines =====
        form.dataset.swakGuarded = 'false';
        form.requestSubmit();
        form.dataset.swakGuarded = 'true';
        // ===== SWAK CHANGE END — 2026-07-02 20:32 CDT — fix null corruption on requestSubmit lines =====

      } catch (e) {
        console.error('SWAK cart guard error:', e);
      }

      button.disabled = false;
      formBusy = false;
      // ===== SWAK CHANGE START — 2026-07-02 20:32 CDT — fix null corruption on swakGuardActive reset =====
      swakGuardActive = false;
      // ===== SWAK CHANGE END — 2026-07-02 20:32 CDT — fix null corruption on swakGuardActive reset =====

    }, true);
  }

  document.querySelectorAll('form.shopify-product-form').forEach(attachGuard);

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches('form.shopify-product-form')) attachGuard(node);
        node.querySelectorAll?.('form.shopify-product-form').forEach(attachGuard);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();
